module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main clearfix",
    staticStyle: {
      "overflow-y": "auto",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "main_middle_right"
  }, [_c('router-link', {
    attrs: {
      "to": "/information"
    }
  }, [_vm._v("用户信息收集")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "bottom": "20px",
      "left": "50%"
    },
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("冀ICP备19019941号")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7301a304"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 525
// module chunks = 2